import React from 'react';
import { node, string, func, oneOf } from 'prop-types';
import { StyledModalButton } from './styles/styled';

var ModalButton = function ModalButton(_ref) {
  var children = _ref.children,
      dataAnalyticsLabel = _ref.dataAnalyticsLabel,
      dataAnalyticsId = _ref.dataAnalyticsId,
      buttonColor = _ref.buttonColor,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'large' : _ref$size,
      onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(StyledModalButton, {
    id: "sharp-modal-buton-1",
    dataAnalyticsLabel: dataAnalyticsLabel,
    dataAnalyticsId: dataAnalyticsId,
    className: "primary",
    alignment: "align-center",
    size: size,
    theme: buttonColor,
    onClick: onClick
  }, children);
};

ModalButton.propTypes = {
  /**
   Optional: specific data-analytics-label for the modal button
  */
  dataAnalyticsLabel: string,

  /**
  Required: specific data-analytics-id for the modal button
  */
  dataAnalyticsId: string.isRequired,

  /**
    Optional: size variation of the button: skinny, small, medium or large
   */
  size: string,

  /**
    Required: Color version of the button
   */
  buttonColor: oneOf(['plum', 'aqua', 'ocean', 'cobalt', 'black', 'white', 'transparent']),

  /**
   Optional: click handler that can be passed down to the base button
   */
  onClick: func,

  /**
  Everything included between opening and closing tags when invoking component
  */
  children: node.isRequired
};
export default ModalButton;